import { render, staticRenderFns } from "./index.vue?vue&type=template&id=51ab5a82&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ab5a82')) {
      api.createRecord('51ab5a82', component.options)
    } else {
      api.reload('51ab5a82', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=51ab5a82&", function () {
      api.rerender('51ab5a82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/Buy/index.vue"
export default component.exports